import { render, staticRenderFns } from "./MultiPaymentTransactions.vue?vue&type=template&id=087163ad&"
import script from "./MultiPaymentTransactions.vue?vue&type=script&lang=ts&"
export * from "./MultiPaymentTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports